import React from 'react';
import { Provider } from 'react-redux';

import {  MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
// import { BrowserRouter as Router } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';

import Root from './Root.js';

const App = ({ store, theme }) => (
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      {/* <Router> */}
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Root />
        </MuiPickersUtilsProvider>
      {/* </Router> */}
    </MuiThemeProvider>
  </Provider>
)

export default App;